"use client"

import { Projector } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ProjectorIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ProjectorIcon = component(Icon)({ as: Projector })
